import * as dataEn from './header.data-en';
import * as dataZh from './header.data-zh';

export const en = dataEn;
export const zh = dataZh;
